<template>
    <section class="teamManageWrap">
        <h2>协作者管理</h2>
        <div class="tableWrap">
            <el-button  type="primary" @click="dialogNewMember = true">新建协作者</el-button>
            <el-table
                :data="teamData"
                stripe
                style="width: 100%"
                class="table"
                v-loading="tableLoading"
            >
                <el-table-column
                    prop="memberName"
                    label="姓名"
                >
                </el-table-column>
                <el-table-column
                    prop="memberPhone"
                    label="手机号"
                >
                </el-table-column>
                <el-table-column
                    label="协作者角色"
                >
                    <template slot-scope="scope">
                        <span  v-if = "scope.row.role == 0">管理员</span>
                        <span  v-else>协作者</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    width="75"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click.native.prevent="showRemoveDialog(scope.row)"
                            type="text"
                            size="small"
                        >
                        移除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationWrap">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :total="total"
                    :page-sizes="[5,10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next,sizes"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <el-dialog
            title="新建协作者"
            :visible.sync="dialogNewMember"
            width = "700px"
            :close-on-click-modal="false"
            class="newMemberDia"
        >
            <el-form :model="newMemberData" ref="newMemberData" :rules="creatMemberRules"  label-width="112px">
                <el-form-item label="协作者" prop = "userName">
                    <el-input
                        v-model.trim="newMemberData.userName"
                        auto-complete="off"
                        placeholder="请输入姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop = "phone">
                    <el-input
                        v-model.trim="newMemberData.phone"
                        auto-complete="off"
                        placeholder="请输入手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="协作者角色"
                    prop ='role'
                    class="radioItem"
                >
                    <div>
                        <el-radio
                            v-model="newMemberData.role"
                            label="0"
                        >管理员</el-radio>
                        <span class="radioTips">工作台所有权限</span>
                    </div>
                    <div>
                        <el-radio
                            v-model="newMemberData.role"
                            label="1"
                        >发券人</el-radio>
                        <span class="radioTips">有发券管理权限，无购券和充值和协作者管理权限</span>
                    </div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button  @click.prevent.stop="dialogNewMember = false">取 消</el-button>
                <el-button  type="primary" @click="doNewGroupMember" :loading="createGroupMemberPreBtnLoading">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :visible.sync="dialogRemoveMember"
            width ="400px"
            title="移除协作者"
            custom-class = "askDialog"
            :show-close = "false"
        >
            <span class="askContent">是否要移除【协作者-{{willRemoveData.memberName}}】</span>
            <div slot="footer" class="dialog-footer">
                <el-button @click="hiddenRemoveDialog">取 消</el-button>
                <el-button type="primary" @click="doRemove" :loading="removeGroupMemberPreBtnLoading">确 定</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
// import tophead from '../components/head'
// import leftbar from '../components/leftbar'
import { Message } from 'element-ui'
import {mapState} from 'vuex'
export default {
  beforeMount: function () {
    // console.log(store)

    this.doGetAllMember()
  },
  mounted: function () {
    this.omgTrack('es_chuxingquan_xieyi_cooperator_sw', '出行券模块打开协作者管理页面')
  },
  computed: {
    ...mapState('teamManage', [
      'teamData',
      'total',
      'tableLoading',
      'createGroupMemberSuccess',
      'removeGroupMemberSuccess'
    ])
  },
  methods: {
    showRemoveDialog: function (MemberData) {
    //   console.log(MemberData)
      this.willRemoveData = MemberData
      this.dialogRemoveMember = true
    },
    hiddenRemoveDialog: function () {
      // this.willRemoveData = {}
      this.dialogRemoveMember = false
    },
    doNewGroupMember: function () {
      this.$refs.newMemberData.validate((valid) => {
        if (valid) {
          this.createGroupMemberPreBtnLoading = true
          const {phone, userName, role} = this.newMemberData
          this.$store.dispatch('teamManage/createGroupMember', {
            phone,
            userName,
            role,
            groupId: this.$store.state.header.selfGroup.groupId
          })
        } else {
          return false
        }
      })
    },
    doRemove: function () {
      // console.log(this)
      this.removeGroupMemberPreBtnLoading = true
      const {memberName: userName, memberId} = this.willRemoveData
      const {groupId, groupName} = this.$store.state.header.selfGroup
      this.$store.dispatch('teamManage/removeGroupMember', {
        groupId,
        groupName,
        memberId,
        userName
      })
    },
    handleSizeChange: function (val) {
      this.pageSize = val
      this.pageNum = 1
      this.doGetAllMember()
    },
    handleCurrentChange: function (val) {
      this.pageNum = val
      this.doGetAllMember()
    },
    doGetAllMember: function () {
      this.$store.commit('teamManage/openLoading')
      this.$store.dispatch('teamManage/getAllMember', {
        groupId: this.$store.state.header.selfGroup.groupId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
    }
    // ...mapActions('teamManage', [
    //   'getAllMember',
    //   'createGroupMember'
    // ])
  },
  watch: {
    createGroupMemberSuccess: function (val) {
    //   console.log('watchMember', val)
      if (val) {
        this.dialogNewMember = false

        if (val.status === 0) {
          Message.success('协作者新建成功')
        } else {
          Message.error(val.message)
        }
        this.$store.commit('teamManage/createGroupMemberSuccess', {res: false})
        this.pageNum = 1
        this.doGetAllMember()
      }
    },
    removeGroupMemberSuccess: function (val) {
      if (val) {
        this.dialogRemoveMember = false

        if (val.status === 0) {
          Message.success('移除协作者成功')
          const teamDataLen = this.teamData.length
          let allPagesNum = Math.ceil(this.total / this.pageSize)
          if (allPagesNum > 1) {
            if (this.pageNum === allPagesNum && teamDataLen === 1) {
              // 最后一页并且只有一个数据
              this.pageNum = this.pageNum - 1
            }
          } else {
            this.pageNum = 1
          }
        } else {
          Message.error(val.message)
        }
        this.$store.commit('teamManage/removeGroupMemberSuccess', {res: false})

        this.doGetAllMember()
      }
    },
    dialogNewMember: function (val) {
      if (!val) {
        this.$refs.newMemberData.resetFields()
        this.createGroupMemberPreBtnLoading = false
      }
    },
    dialogRemoveMember: function (val) {
      if (!val) {
        this.removeGroupMemberPreBtnLoading = false
      }
    }
  },
  data () {
    return {
      dialogNewMember: false,
      newMemberData: {
        userName: '',
        role: '0',
        phone: ''
      },
      dialogRemoveMember: false,
      willRemoveData: {},
      createGroupMemberPreBtnLoading: false,
      removeGroupMemberPreBtnLoading: false,
      creatMemberRules: {
        userName: [
          { required: true, message: '请输入协作者姓名', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_\u4e00-\u9fa5]+$/, message: '请输入有效的用户名', trigger: 'blur' },
          { min: 1,
            max: 10,
            message: '姓名长度在 1 到 10 个字符',
            trigger: 'blur',
            transform (value) {
              return value.trim()
            }
          }
        ],
        phone: [
          { required: true, message: '请输入协作者手机号', trigger: 'blur' },
          { pattern: /^1[1|3|4|5|6|7|8|9][0-9]\d{8}$/, message: '请输入有效的手机号', trigger: 'blur' }
        ]
      },
      pageNum: 1,
      pageSize: 5
    }
  }
}
</script>
<style  lang="stylus">
.teamManageWrap
    .el-dialog__header
        padding-left 40px
        padding-top 30px
    .el-dialog__title
        font-size  20px
        color  #333333
        font-weight bold
    .el-dialog__headerbtn
        right 30px
        top 30px
    .el-form-item__label
        padding-right  20px
        font-size  14px
        color  #666666
    .el-input
        width 315px
    .el-form-item
        margin-bottom  20px
    .el-input__inner
        border  1px solid #CCCCCC
        height 36px
        line-height 36px
        border-radius 0
    .el-radio
        color #333
    .el-radio__input.is-checked .el-radio__inner
        color #3468FF
        background #3468FF
        border-color #3468FF
    .el-radio__input.is-checked+.el-radio__label
        color #333
    .el-dialog__footer
        text-align center
    .radioTips
        color #999
        padding-left 10px
.askDialog
    text-align center
    .el-dialog__header
        padding: 20px 20px 10px
.el-icon-loading
    margin 0

.askContent
    font-size: 14px;
    color: #666666;
.dialog-footer
    .el-button
        height 44px
        line-height 1
        padding 0 44px
    .el-button+.el-button
        margin-left 20px
.newMemberDia
    .el-dialog__body
        padding-bottom 0
    .el-dialog__footer
        padding 5px 20px 40px
    .radioItem
        .el-form-item__content,.el-form-item__label
            line-height 30px
.tableWrap
    padding 20px
    .table
        margin-top 20px
.paginationWrap
    text-align right
    padding-top 20px
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li
        border-radius 0
    .el-pagination.is-background .el-pager li:not(.disabled).active
        background #3468FF
    .el-pagination .el-select .el-input .el-input__inner
        height 28px
        line-height 28px
        border-radius 0
</style>
